// import React from "react";

// export const colors  = {
//   primaryText: "#fffff",
//   secondaryBackground: "#111111"
// }

export const EXPLANATION_CONTENT = [
  {
    Title: 'Explanation',
    Description: ` There are several implementations of the provably fair method, we
        will describe the most common one. With this method each roll-result
        is calculated by the following variables:`
  },
  {
    Title: 'Serverseed',
    Description: `provided by the gambling site`
  },
  {
    Title: 'Nonce',
    Description: ` A number that increases with each random number is needed.`
  },
  {
    Title: 'Clientseed',
    Description: `provided by your browser and adjusted by you`
  },
  {
    Title: 'Hash',
    Description: `Encrypted data`
  }
]

export const EXPLANATION_TABLE_CONTENT = [
  {
    Title: `Before Game`,
    Description: `You will get an encrypted Hash of the Serverseed before you start
    gambling. Sinceyou get it in advance, the site cannot change it
    later. However, it is encrypted, so you cannot calculate your own
    state results in advance (only afterwards if you get the Unhashed
    Serverseed.)`,
    LeftColumn: [
      {
        Content: 'Seed',
        Round: false,
        FirstCircle: 'rightCorner',
        Line: 'diagBotLong'
      },
      { Content: 'Seed', Round: true },
      {
        Content: 'Hash Seed',
        Round: true,
        FirstCircle: 'circle',
        Line: 'diagTop'
      }
    ],
    RightColumn: [
      {
        Content: 'Seed',
        Round: true,
        FirstCircle: 'bottom',
        Line: 'down line'
      },
      {
        Content: 'Hash Seed',
        Round: true,
        FirstCircle: 'left',
        SecondCircle: 'top'
      },
      {
        Content: 'Seed',
        Round: false,
        FirstCircle: 'leftCorner'
      }
    ]
  },
  {
    Title: `Game`,
    Description: `Your browser will generate a random Clientseed. However, you could
    and should adjust this Clientseed before you start. This way you can
    make sure the site does not know your Clientseed before start game
    and server already send you the encrypted Hash of the Serverseed, so
    server cannot change it after getting Clientseed.`,
    LeftColumn: [
      {
        Content: 'Seed',
        Round: false
      },
      {
        Content: 'Outcome',
        Round: false,
        FirstCircle: 'circle',
        Line: 'line'
      }
    ],
    RightColumn: [
      {
        Content: 'Seed',
        Round: false,
        PlusSVG: true
      },
      { Content: 'Hash Seed', Round: true, PlusSVG: true },
      {
        Content: 'Nonce 3',
        Round: true,
        ArrowSVG: true,
        ProvEqSVG: true
      },
      {
        Content: 'Outcome',
        Round: false,
        FirstCircle: 'left'
      }
    ]
  },
  {
    Title: `After Game`,
    Description: `Now if you make a bet the Nonce starts with 0 or 1. After each bet
    you make, the Nonce number will go up by 1`,
    border: 'border-b',
    LeftColumn: [
      {
        Content: 'Seed',
        Round: true,
        FirstCircle: 'circle',
        Line: 'diagBot'
      },
      {
        Content: 'Hash Seed',
        Round: true,
        FirstCircle: 'circle',
        Line: 'diagTop'
      }
    ],
    RightColumn: [
      {
        Content: 'Seed',
        Round: true,
        FirstCircle: 'left'
      }
    ]
  }
]
